import {
  AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
  Paper, Badge, Drawer, Divider, List, ListItem, ListItemText,
  useMediaQuery, Menu
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from '@mui/icons-material/Menu';
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const Mainnavbar = () => {
  const navigate = useNavigate();
  const [showContainer, setShowContainer] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const isMobile = useMediaQuery('(max-width:600px)');

  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("vendorId");
    setShowContainer(false);
    setDrawerOpen(false);
    handleMenuClose();
    navigate("/");
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      const vendorId = localStorage.getItem("vendorId");
      if (!vendorId) return;

      const response = await axios.get(`https://backend.maamaas.com/food/notifications/${vendorId}`);
      setNotifications(response.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([
        { id: 1, message: "Welcome to MAAMAA'S!" },
        { id: 2, message: "Your order has been delivered." },
      ]); // fallback
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // Handle menu open/close for mobile & desktop
  const handleMenuOpen = (event) => setMenuAnchorEl(event.currentTarget);
  const handleMenuClose = () => setMenuAnchorEl(null);

  const DrawerContent = (
    <Box sx={{ width: 250, padding: 2 }} role="presentation">
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>
      <Divider />
      <List>
        <ListItem button onClick={() => navigate("/landingpagesubscription")}>
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem button onClick={handleLogout}>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1300 }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {/* Left side: Logo */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#fff", fontSize: { xs: "22px", sm: "26px" }, cursor: "pointer" }}
              onClick={() => 
                // navigate("/foodladingpage")
                navigate("/landingpagesubscription")
              }
            >
              MAAMAA'S
            </Typography>
          </Box>

          {/* Right Side */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>

            {/* <Link to="/notificationcontext">
              <IconButton sx={{ color: "white" }}>
                <Badge badgeContent={notifications.length} color="error">
                  <NotificationsIcon fontSize="large" />
                </Badge>
              </IconButton>
            </Link> */}

            <IconButton
              onClick={isMobile ? handleMenuOpen : () => setShowContainer(!showContainer)}
              sx={{ color: "white" }}
            >
              <AccountCircleIcon fontSize="large" />
            </IconButton>
          </Box>
        </Toolbar>

        {/* Desktop Account Menu */}
        {showContainer && !isMobile && (
          <Paper
            sx={{
              position: "absolute",
              top: "60px",
              right: "10px",
              width: "120px",
              backgroundColor: "white",
              boxShadow: 3,
              borderRadius: "8px",
              zIndex: 1500
            }}
          >
            <MenuItem onClick={() => navigate("/landingpagesubscription")}>Subscription </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Paper>
        )}

        {/* Mobile Account Menu */}
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{
            paper: {
              sx: {
                marginTop: '8px',
                width: "130px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                zIndex: 1500,
              }
            }
          }}
        >
          <MenuItem onClick={() => navigate("/landingpagesubscription")}>Subscription </MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </AppBar>

      {/* Drawer for Mobile Navigation */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        {DrawerContent}
      </Drawer>
    </>
  );
};

export default Mainnavbar;
